export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'IT',
  'merchantReturnLink': 'https://www.timberland.it/it-it/assistenza-clienti/resi ',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
